import styled from '@emotion/styled';
import { ssColorVeryDarkGrey } from '../constants/style-constants';

const UnderlineDivider = styled.hr`
  border-top: 2px solid ${ssColorVeryDarkGrey};
`;

export default UnderlineDivider;
